import React from "react";
import "./LabCard.css";

const LabCard = ({ cardData }) => {
  return (
    <section id="lab-card" className="lab-card">
      <div className="section-title">
        <h1>Labs consist of a combination of the following stations</h1>
        <div>
          <span className="description-title">
            Labs feature a comprehensive combination of interactive stations for
            practical learning in advanced industrial technologies.
          </span>
        </div>
      </div>

      <div className="">
        <div className="isotope-layout">
          <div className="row gy-4 isotope-container">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="col-lg-4 col-md-6 portfolio-item isotope-item"
              >
                <div className="portfolio-content h-100">
                  <a
                    href={card.imageUrl}
                    data-gallery="portfolio-gallery"
                    className="glightbox"
                  >
                    <img
                      src={card.imageUrl}
                      className="lab-card-img"
                      alt={card.title}
                    />
                  </a>
                  <div className="portfolio-info">
                    <h4>
                      <a href={card.linkUrl} title="More Details">
                        <i className={card.icon}></i> {card.title}
                      </a>
                    </h4>
                    <p>{card.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LabCard;
